module.exports = __webpack_public_path__ + "static/media/scratch-off-qrc-combo.0bddd4a9.svg";